import axios from "axios";
import { scence, imgEdit, getImgItemList, delImgList } from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "bimVectorResources",
  props: ["sceneId", "getSchemeTree"],
  components: { MapModal },
  data() {
    return {
      // 假数据
      uploadFilesList: [],
      graphicLayer: [],
      radio: "kml",
      input: "",
      bimVectorResources: {
        title: "导入矢量数据",
        id: "bimVectorResources", // id和ref使用的同一个
      },
      modalNode: {
        bimVectorResources: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 7,
            y: -81,
            // left: 22,
            // top:20
            unit: "%", // 默认px
          },
          width: "60%", // 宽度配置 默认450px
          height: "85%", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      ifSort: false,
      renewState: "add",
      imgItem: [],
      fileItem: [],
      disabled: false,
      loading: false,
    };
  },

  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
    // console.log("created");
    this.vectorData();
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    closeVector() {
      console.log("关开");
      this.modalNode.bimVectorResources.show = false;
    },
    onCancel() {
      console.log("关开");
      this.modalNode.bimVectorResources.show = false;
    },
    vectorData() {
      // 请求附件列表
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        pId: this.sceneId,
      };
      getImgItemList(params).then((res2) => {
        // console.log(res2.data.data);
        this.uploadFilesList = res2.data.data;
        console.log(res2.data.data);
        //  console.log(this.uploadFilesList);
      });
    },
    // 点击上传
    httpRequest(item) {
      this.imgItem = [];
      this.fileItem = [];
      // debugger
      console.log(item);
      this.modalNode.bimVectorResources.loading = true;
      item.file.remarks = "";
      // //获取单选框选择项
      // var temp=document.getElementsByName("radio");
      // var fileType="";
      // for(var i=0;i<temp.length;i++)
      // {
      //   if(temp[i].checked)
      //   {
      //     fileType=temp[i].value;
      //   }
      // }
      // 限制文件大小和类型
      const fileSuffix = item.file.name.substring(
        item.file.name.lastIndexOf(".") + 1
      );
      // const errType = [fileType];
      // if (item.file.size / 1024 / 1024/10 > 1) {
      //   this.$message({
      //     type: "error",
      //     message: "文件过大，请上传小于10MB的文件！",
      //   });
      //   return;
      // }
      // if (errType.indexOf(fileSuffix) === -1) {
      //   this.$message({
      //     type: "error",
      //     message: "上传文件只能是"+errType[0]+"格式！",
      //   });
      //   return;
      // }
      if (fileSuffix == "kml") {
        $("#inputFile").val(item.file.name);
        //上传kml
        let formData = new FormData();
        formData.append("files", item.file);
        formData.append("scenesId", this.sceneId);
        formData.append(
          "projectId",
          window.sessionStorage.getItem("nowProjectId")
        );
        formData.append("pId", 334065965994053);
        formData.append("type", false);
        axios
          .post("/baseIP/KmlInfo/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + window.sessionStorage.getItem("token"),
              "X-Authorization":
                "Bearer " + window.sessionStorage.getItem("refreshToken"),
            },
          })
          .then(
            (res) => {
              this.modalNode.bimVectorResources.loading = false;
              if (res.data.code == 200 || res.data.code == 204) {
                this.vectorData();
                this.getSchemeTree();
                this.$notify({
                  title: "上传成功",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                this.$notify({
                  title: "上传失败",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              }
            },
            (err) => {
              this.$notify({
                title: "上传失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          );
      } else if (fileSuffix == "json") {
        $("#inputFile").val(item.file.name);
        //上传json
        let formData = new FormData();
        formData.append("files", item.file);
        formData.append("scenesId", this.sceneId);
        formData.append(
          "projectId",
          window.sessionStorage.getItem("nowProjectId")
        );
        formData.append("pId", 334071844278341);
        formData.append("type", false);
        axios
          .post("/baseIP/ShpInfo/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + window.sessionStorage.getItem("token"),
              "X-Authorization":
                "Bearer " + window.sessionStorage.getItem("refreshToken"),
            },
          })
          .then(
            (res) => {
              this.modalNode.bimVectorResources.loading = false;
              if (res.data.code == 200 || res.data.code == 204) {
                this.vectorData();
                this.getSchemeTree();
                this.$notify({
                  title: "上传成功",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                this.$notify({
                  title: "上传失败",
                  message: "",
                  type: "error",
                  duration: 960,
                  offset: 320,
                });
              }
            },
            (err) => {
              this.$notify({
                title: "上传失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          );
      } else {
      }
    },
    // 保存按钮
    submit(data) {
      let objData = {
        id: data.id,
        projectId: data.projectId,
        pId: data.pId,
        name: data.name,
        remarks: data.remarks,
      };
      imgEdit(objData).then((res) => {
        this.getSchemeTree();
        this.$notify({
          title: "保存成功",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        this.vectorData();
      });
    },
    // 上传之前对文件作限制
    beforeUpload(file) {
      //获取单选框选择项
      var temp = document.getElementsByName("radio");
      var fileType = "";
      for (var i = 0; i < temp.length; i++) {
        if (temp[i].checked) {
          fileType = temp[i].value;
        }
      }
      // 限制文件大小和类型
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(file);
      const errType = [fileType];
      if (file.size / 1024 / 1024 / 10 > 1) {
        this.$message({
          type: "error",
          message: "文件过大，请上传小于10MB的文件！",
        });
        return false;
      }
      if (errType.indexOf(fileSuffix) === -1) {
        this.$message({
          type: "error",
          message: "上传文件只能是" + errType[0] + "格式！",
        });
        return false;
      }
    },
    // 自定义方法
    toggleFold(item, state) {
      item.state = state;
    },
    filterNode(value, data, node) {
      console.log("搜素自己逻辑,以后会和ajax配合使用");
    },
    // 节点被点击时的回调
    nodeClick(data) {
      console.log("节点被点击时的回调");
      console.log(data);
    },
    videoSurveilClick() {},
    // 编辑
    handleEdit(data, node) {
      console.log(data);
      console.log(node);
      // if(ref.currentNode)
      //    console.log(ref.currentNode.node);
      // console.log(this.$refs.zhang.submitData);
      this.renewState = "edit";
      this.ifSort = true;
      let { name } = data.form;
      this.$refs.zhang.submitData.parentId = "0";
      this.$refs.zhang.submitData.name = name;

      // this.$refs.zhang.submitData = data.id;
    },
    // 删除
    handleDelete(data) {
      console.log(data);
    },

    // 新增
    addCategory() {
      this.renewState = "add";
      // this.modalNode.bimVectorResources.foot.addCategory.disabled = true;
      this.ifSort = true;
    },
    renewClose() {
      this.renewState = "add";
      this.ifSort = false;
    },

    // 初始化
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },
  watch: {},
  destroyed() {},
};
